"use client";

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Image from 'next/image';
import { useComingSoon } from '../../context/ComingSoonContext';

export default function MobileHeader({ setMobileOpen }) {
  const pathname = usePathname();
  const isRestaurantPage = pathname.includes('/restaurant/');
  const isCheckoutPage = pathname.includes('/checkout');
  const isOrdersPage = pathname.includes('/orders');
  const isAccountPage = pathname.includes('/account');
  const { openPopup } = useComingSoon();
  
  // Get page title based on current path
  const getPageTitle = () => {
    if (isRestaurantPage) {
      const slug = pathname.split('/').pop();
      return slug.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    } else if (isCheckoutPage) {
      return "Checkout";
    } else if (isOrdersPage) {
      if (pathname.includes('/orders/')) {
        return "Order Details";
      }
      return "My Orders";
    } else if (isAccountPage) {
      if (pathname.includes('/profile')) {
        return "My Profile";
      } else if (pathname.includes('/payments')) {
        return "Payment Methods";
      } else if (pathname.includes('/addresses')) {
        return "My Addresses";
      }
      return "My Account";
    }
    return '';
  };
  
  return (
    <div className="md:hidden fixed top-0 left-0 right-0 bg-white border-b border-gray-100 shadow-sm z-40">
      <div className="flex items-center justify-between px-4 h-16">
        {isRestaurantPage || isCheckoutPage || isOrdersPage || (isAccountPage && pathname !== '/account') ? (
          <>
            {/* Back button for interior pages */}
            <Link 
              href={
                isRestaurantPage ? "/" : 
                isCheckoutPage ? "/" :
                isOrdersPage && pathname.includes('/orders/') ? "/orders" :
                isAccountPage ? "/account" : "/"
              } 
              className="flex items-center justify-center p-2 text-gray-700 rounded-md hover:bg-gray-100 active:bg-gray-200 transition-colors"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
            </Link>
            
            {/* Page title */}
            <h1 className="text-lg font-semibold text-gray-800 truncate flex-1 text-center">
              {getPageTitle()}
            </h1>
            
            {/* Empty div for spacing */}
            <div className="w-8"></div>
          </>
        ) : (
          <>
            {/* Logo for home page */}
            <Link href="/" className="flex items-center">
              <div className="relative w-10 h-10 mr-2">
                <img 
                  src="/images/logo-oval-mobile.svg" 
                  alt="OpenMenu.pk Logo" 
                  className="w-full h-full" 
                />
              </div>
              <h1 className="text-lg font-bold text-primary">OpenMenu.pk</h1>
            </Link>
            
            {/* Menu Button */}
            <button 
              className="p-2 rounded-md hover:bg-gray-100 active:bg-gray-200 text-gray-700 transition-colors focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50"
              onClick={() => setMobileOpen(true)}
              aria-label="Open menu"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </>
        )}
      </div>
    </div>
  );
} 